import { useCallback, useRef } from 'react';
import { useToast } from '../../../components/ui/Toast';

/**
 * Adapts the CampaignOS prototype toast signature — toast(message, { tone, icon }) — onto VMS's
 * useToast() (success/error/warning/info). `icon` is ignored (VMS toasts carry their own icon).
 *
 * Returns a STABLE callback (via a ref to the latest useToast value). This matters because some
 * screens (e.g. Vendor Audience) list `toast` in a usePageChrome dependency array — an unstable
 * function there re-fires the chrome effect every render → "Maximum update depth exceeded".
 */
const TONE_TO_TYPE = { success: 'success', info: 'info', warning: 'warning', coral: 'error', error: 'error' };

export function useShellToast() {
  const vt = useToast();
  const ref = useRef(vt);
  ref.current = vt;
  return useCallback((message, opts = {}) => {
    const type = TONE_TO_TYPE[opts?.tone] || 'info';
    const api = ref.current;
    (api[type] || api.info)(message);
  }, []);
}

export default useShellToast;
